import { Modal, ModalBody } from 'reactstrap'
import React from 'react'
import Signin from './Signin'
import Signup from './Signup'
import useTranslation from '../hooks/UseTranslation'
import ToastAccountCreated from './ToastAccountCreated'

const SigninModal = ({ isOpen, ...props }) => {
  const { t } = useTranslation()
  const [showSignin, setShowSignin] = React.useState(true)
  const [showSignupToast, setShowSignupToast] = React.useState(false)

  React.useEffect(() => setShowSignin(true), [isOpen])
  const getHeader = () => (
    <div className='mb-2 position-relative d-flex justify-content-between'>
      <img
        src='/content/svg/logo-square.svg'
        alt='...'
        style={{ maxWidth: '4rem' }}
        className='img-fluid mb-3'
      />
      <a
        className='text-primary'
        style={{ cursor: 'pointer', right: 0 }}
        onClick={props.toggle}
      >
        <svg className='svg-icon w-3rem h-3rem'>
          <use xlinkHref='/content/svg/orion-svg-sprite.svg#close-1' />
        </svg>
      </a>
    </div>
  )
  return (
    <div>
      <ToastAccountCreated
        isOpen={showSignupToast}
        callback={() => props.callback()}
        showProgress={props.showProgress}
      />
      <Modal
        isOpen={isOpen && showSignin}
        toggle={props.toggle}
        backdrop
        backdropClassName='modal-backdrop invisible'
      >
        <ModalBody>
          {getHeader()}
          <div>
            <h2 className='mb-2'>{t('signin_modal_signin')}</h2>
            <Signin
              showProgress={props.showProgress}
              onSignupClick={() => setShowSignin(false)}
              callback={props.callback}
            />
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isOpen && !showSignin}
        toggle={props.toggle}
        backdropClassName='modal-backdrop invisible'
        backdrop
      >
        <ModalBody>
          {getHeader()}
          <h2 className='mb-2'>{t('signin_modal_signup')}</h2>
          <Signup
            md='12'
            className='p-0'
            isGuru={false}
            onSuccess={(accountCreated = true) => {
              if (accountCreated) {
                // inform user that account was created
                setShowSignupToast(true)
              } else {
                // it's a login, so call back immediately
                props.callback()
              }
            }}
            back={() => setShowSignin(true)}
          />
        </ModalBody>
      </Modal>
      {isOpen && (
        <div className={`modal-backdrop ${isOpen ? 'show' : 'fade'}`} />
      )}
      {/* todo: do nice fading */}
    </div>
  )
}

export default SigninModal
